import React from 'react';

import ListView from '../shared/lists/ListView';
import SalesAppointmentItem from './SalesAppointmentItem';
import CustomTh from '../shared/table/CustomTh';
import useBreakpoints from '../../utilities/useBreakpoints';

const SalesAppointmentList = ({
    addItem,
    canAdd,
    data: { items },
    editItem,
    fetchData
}) => {
    const { isBreakpoint } = useBreakpoints();

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh content="Designer" />
                <CustomTh width={isBreakpoint('md') ? '170px' : ''} content="Appointment" />
                <CustomTh width="75px" style={{ textAlign: 'center' }} hide="sm" content="Areas" />
                <CustomTh hide="md" content="Areas Interested In" />
                <CustomTh width="80px" content="" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item, index) =>
        <SalesAppointmentItem
            editItem={() => editItem(item.id)}
            fetchData={fetchData}
            item={item}
            key={item.id}
        />
    );

    return (
        <ListView
            addItem={addItem}
            canAdd={canAdd}
            itemName="Appointment"
            items={listItems}
            tableHead={tableHead}
        />
    );
}

export default SalesAppointmentList;